<div class="task">
  <div class="container">
    <div class="task__header">
      <div class="title" [routerLink]="['/tasks']">{{ title }} {{ subRegionName ? "in " + subRegionName : "" }}
      </div>
      <button class="my-button-3" *ngIf="user?.id" [routerLink]="['/user-tasks/', user?.referralCode]">My Task</button>
    </div>

    <div class="task__grid" *ngIf="pinnedTasks.length > 0 && !hideFilter">
      <div class="task__card clickable" *ngFor="let task of pinnedTasks" (click)="openPinnedDetail(task)">
        <div class="thumb">
          <img [src]="task.image" [alt]="task.name" />
        </div>
        <div class="content">
          <div class="name">{{ task?.memberShopProduct?.name || task?.userName }}</div>
          <div class="description">{{ task.description }}</div>
        </div>
      </div>
    </div>
    <div class="search-container" *ngIf="!hideFilter">
      <span class="text-found">
        {{ tasksPagination.totalRecords || 0 }} task{{ tasksPagination.totalRecords !== 1 ? "s" : "" }}
        found
      </span>
      <div class="search">
        <div>
          <i class="fas fa-search"></i>
        </div>
        <input type="text" class="form-control" placeholder="Search by product name or task description..."
          [(ngModel)]="searchTerm" (input)="onSearchChange()" />
        <button type="button" (click)="clearSearch()" *ngIf="searchTerm">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div *ngIf="!referralCode" class="other-input">
        <div class="form-group">
          <label for="regionSelect" class="form-label small mb-0">Region</label>
          <select id="regionSelect" class="form-select form-control" [(ngModel)]="regionId">
            <option value="">All Regions</option>
            <option *ngFor="let region of regions" [value]="region.regionId">{{ region.name }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="subRegionSelect" class="form-label small mb-0">Sub Region</label>
          <select id="subRegionSelect" class="form-select form-control" (change)="loadAvailableTasks(1)"
            [(ngModel)]="subRegionId">
            <option value="">All Sub Regions</option>
            <option *ngFor="let subRegion of filteredSubRegions" [value]="subRegion.subRegionId">
              {{ subRegion.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="special-tabs" *ngIf="!referralCode && !hideFilter">
      <div class="special-tabs__chips">
        <ng-container *ngFor="let item of specialCategories">
          <button class="special-tabs__tab" type="button" (click)="loadProducts(item)"
            [class.active]="selectedTab === item" [attr.aria-pressed]="selectedTab === item">
            <i [class]="getCategoryIcon(item)"></i>
            <span class="text">{{ item }}</span>
          </button>
        </ng-container>
        <button class="special-tabs__tab remove-tab" *ngIf="selectedTab" type="button" (click)="loadProducts()">
          <i class="fas fa-times"></i>
          <span class="text">Clear</span>
        </button>
      </div>
    </div>

    <ng-container *ngIf="isLoading; else afterLoading">
      <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
        <p class="mt-2">Loading tasks...</p>
      </div>
    </ng-container>

    <ng-template #afterLoading>
      <div class="task__grid horizontal d-md-none">
        <div style="background-color: #fff; border-radius: 0.5rem" *ngFor="let task of tasks">
          <div class="task__card" [class.bg-pink]="(!task.is_file_uploaded && !task.appliedByMe) || task.appliedByMe"
            [class.bg-grey]="task.appliedByMe && task.is_file_uploaded">
            <div class="media-col">
              <div class="thumb">
                <img [src]="task.image" [alt]="task.name" />
              </div>
              <div class="tag-row" *ngIf="task.tags">
                <span class="tag-badge"
                  [ngClass]="{ survey: task.tags === 'survey', taste: task.tags === 'taste_test', micro: task.tags === 'micro_job' }">
                  {{ specialTags[task.tags] }}
                </span>
                <span class="tag-badge level" *ngIf="task.level_required"> LVL {{ task.level_required }} </span>
              </div>
            </div>
            <div class="d-flex justify-content-between position-relative">
              <div class="content">
                <div class="name">{{ task?.memberShopProduct?.name || task?.userName }}</div>
                <div class="description" [class.expand]="task.expand">{{ task.description }}</div>
                <small class="description__btn" *ngIf="task.description?.length > 134"
                  (click)="task.expand = !task.expand">
                  {{ task?.expand ? "Less" : "More" }} <i class="fas" [class.fa-chevron-down]="!task.expand"
                    [class.fa-chevron-up]="task.expand"></i>
                </small>

                <div class="d-flex mt-auto status-row" style="gap: 0.5rem">
                  <span class="status-icon" [ngClass]="{
                      'text-success': task.is_approved,
                      'text-warning': !task.is_approved && task.appliedByMe,
                      'text-danger': !task.appliedByMe && task.isApplied,
                      'text-muted': !task.appliedByMe && !task.isApplied
                    }"
                    [attr.title]="task.is_approved ? 'Approved' : task.appliedByMe ? 'Applied' : task.isApplied ? 'Unavailable' : 'Pending'"
                    [attr.aria-label]="task.is_approved ? 'Approved' : task.appliedByMe ? 'Applied' : task.isApplied ? 'Unavailable' : 'Pending'">
                    <i class="fas" [ngClass]="{
                        'fa-check-circle': task.is_approved,
                        'fa-hourglass-half': !task.is_approved && task.appliedByMe,
                        'fa-ban': !task.appliedByMe && task.isApplied,
                        'fa-clock': !task.appliedByMe && !task.isApplied
                      }"></i>
                  </span>
                  <span class="points" [attr.title]="task.points + ' points'"
                    [attr.aria-label]="task.points + ' points'"> <i class="fas fa-star text-warning"></i> {{ task.points
                    }} </span>
                </div>

                <ng-container *ngIf="task.appliedByMe && !task.is_file_uploaded">
                  <span class="countdown-badge" title="Submit before time runs out" aria-label="Countdown">
                    <i class="fas fa-clock"></i>
                    <span>{{ task.countdown_limit || "00:00:00" }}</span>
                  </span>
                </ng-container>
              </div>
              <div class="content mt-auto" style="gap: 0.5rem">
                <div class="d-flex" style="gap: 0.5rem">
                  <ng-container *ngIf="!task.appliedByMe && task.isApplied">
                    <span class="status-icon text-muted" title="Unavailable" aria-label="Unavailable">
                      <i class="fas fa-ban"></i>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="task.appliedByMe && task.is_file_uploaded">
                    <span class="status-icon text-success" title="Completed" aria-label="Completed">
                      <i class="fas fa-check-double"></i>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!task.is_file_uploaded">
                    <ng-container *ngIf="task.appliedByMe; else applyTaskButton">
                      <button class="icon-btn" (click)="openApplyModal(task)" title="Submit Task"
                        aria-label="Submit Task">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </ng-container>
                    <ng-template #applyTaskButton>
                      <button class="icon-btn" *ngIf="!task.appliedByMe && !task.isApplied" (click)="applyTask(task)"
                        title="Accept Task" aria-label="Accept Task">
                        <i class="fas fa-plus-circle"></i>
                      </button>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="this.user?.id && !hideFilter">
                    <button class="icon-btn" [class.teal]="!task.isPinned" [class.error]="task.isPinned"
                      (click)="pinTask(task)" [attr.title]="task.isPinned ? 'Unpin' : 'Pin'"
                      [attr.aria-label]="task.isPinned ? 'Unpin' : 'Pin'">
                      <i class="fa-solid fa-thumbtack"></i>
                    </button>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="referralCode">
                <span class="payment-badge" [class.paid]="task.is_paid" [class.unpaid]="!task.is_paid"
                  [attr.title]="task.is_paid ? 'Paid' : 'Unpaid'" [attr.aria-label]="task.is_paid ? 'Paid' : 'Unpaid'">
                  <i class="fas" [ngClass]="{ 'fa-money-bill-wave': task.is_paid, 'fa-money-bill': !task.is_paid }"></i>
                  <span class="label">{{ task.is_paid ? "Paid" : "Unpaid" }}</span>
                </span>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-container *ngIf="tasks.length === 0">
          <div class="no-data">No data found</div>
        </ng-container>
      </div>

      <div class="desktop-table d-md-block d-none">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Product</th>
                <th scope="col" width="30%">Task</th>
                <th scope="col">Status</th>
                <th scope="col" width="130px">Points Awarded</th>
                <th scope="col" *ngIf="referralCode" width="130px">Payment Status</th>
                <th scope="col" style="text-align: right; width: 165px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of tasks"
                [class.bg-pink]="(!task.is_file_uploaded && !task.appliedByMe) || task.appliedByMe"
                [class.bg-grey]="task.appliedByMe && task.is_file_uploaded">
                <td>
                  <div style="display: grid; gap: 0.75rem; grid-template-columns: 100px 1fr">
                    <img [src]="task.image" [alt]="task.name" class="task-image" (click)="viewProduct(task)" />
                    <div class="d-flex flex-column">
                      <div (click)="viewProduct(task)" style="font-size: 1.1rem; font-weight: 500; line-height: 1.2">
                        {{ task?.memberShopProduct?.name || task?.userName }}
                      </div>
                      <div class="mt-1">
                        <span class="text-nowrap"
                          [ngClass]="{ 'badge-blue': task.tags === 'survey', 'badge-purple': task.tags === 'taste_test', 'badge-teal': task.tags === 'micro_job' }"
                          *ngIf="task.tags">{{ specialTags[task.tags] }}</span>
                        <span class="text-nowrap badge-teal ml-1" *ngIf="task.level_required">LVL {{ task.level_required
                          }}</span>
                        <span class="text-nowrap badge-grey ml-1">
                          {{ task?.memberShopProduct?.subRegionName || 'All Region' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="description-rules" [class.expand]="task.expand">
                    {{ task.description }}
                  </div>
                  <small class="description-rules__btn" *ngIf="task.description?.length > 134"
                    (click)="task.expand = !task.expand">
                    {{ task?.expand ? "Less" : "More" }} <i class="fas" [class.fa-chevron-down]="!task.expand"
                      [class.fa-chevron-up]="task.expand"></i>
                  </small>
                </td>
                <!-- <td>{{ task.is_approved ? "Approved" : task.appliedByMe ? "Applied" : task.isApplied ? "Unavailable" : "Pending" }}</td> -->
                <td>
                  <div *ngIf="task.is_approved" class="badge-success">Approved</div>
                  <div *ngIf="!task.is_approved && task.appliedByMe" class="badge-grey">Applied</div>
                  <div *ngIf="!task.is_approved && !task.appliedByMe && task.isApplied" class="badge-danger">Unavailable
                  </div>
                  <div *ngIf="!task.is_approved && !task.appliedByMe && !task.isApplied" class="badge-warning">Pending
                  </div>
                </td>
                <td>{{ task.points }}</td>

                <td *ngIf="referralCode">
                  <span class="my-button-3 small success" *ngIf="task.is_paid">Paid</span>
                  <span class="my-button-3 small error" *ngIf="!task.is_paid">Unpaid</span>
                </td>
                <td style="align-content: flex-end; text-align: right;">
                  <ng-container *ngIf="isAdmin">
                    <div class="d-flex mb-2" style="gap: 0.5rem; justify-content: end">
                      <ng-container *ngIf="task.type !== 'normal' && !task.is_file_uploaded">
                        <button class="my-button-3 small" [class.warning]="task.is_paused"
                          [class.error]="!task.is_paused" (click)="handlePauseTask(task)">
                          <i class="fa-solid"
                            [ngClass]="{ 'fa-pause': !task.is_paused, 'fa-play': task.is_paused }"></i>
                          {{ task.is_paused ? "Resume" : "Pause" }}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="task.type === 'unlimited_once'">
                        <button class="my-button-3 small error" (click)="deleteTask(task)">
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </ng-container>
                      <button class="my-button-3 small error" (click)="deleteTask(task)">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </ng-container>
                  <div class="d-flex" style="gap: 0.5rem; justify-content: end">
                    <ng-container *ngIf="!task.appliedByMe && task.isApplied">
                      <span class="my-button-3 small gray">Unavailable</span>
                    </ng-container>
                    <ng-container *ngIf="task.appliedByMe && task.is_file_uploaded">
                      <span class="my-button-3 small success">Completed</span>
                    </ng-container>
                    <ng-container *ngIf="!task.is_file_uploaded">
                      <ng-container *ngIf="task.appliedByMe; else applyTaskButton">
                        <button class="my-button-3 small secondary" (click)="openApplyModal(task)">Submit Task</button>
                      </ng-container>
                      <ng-template #applyTaskButton>
                        <button class="my-button-3 small" *ngIf="!task.appliedByMe && !task.isApplied"
                          (click)="applyTask(task)">Accept Task</button>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="this.user?.id">
                      <button class="my-button-3 small" [class.teal]="!task.isPinned" [class.error]="task.isPinned"
                        (click)="pinTask(task)">
                        <i class="fa-solid fa-thumbtack"></i>
                      </button>
                    </ng-container>
                  </div>

                  <ng-container *ngIf="task.appliedByMe && !task.is_file_uploaded">
                    <span class="text-muted small">Submit Before {{ task.countdown_limit || 0 }}</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="no-data" *ngIf="tasks.length === 0">No data found</div>
      </div>
    </ng-template>

    <!-- Pagination Controls -->
    <div class="pagination-container" *ngIf="tasksPagination.totalRecords > 5">
      <div class="pagination-controls">
        <div class="page-size-selector">
          <label for="pageSize">Items per page:</label>
          <select id="pageSize" [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="form-select form-select-sm">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
        </div>

        <nav aria-label="Page navigation">
          <ul class="pagination pagination-sm">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="onPageChange(1)" [attr.aria-label]="'First page'">
                <span aria-hidden="true">&laquo;&laquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="onPageChange(currentPage - 1)" [attr.aria-label]="'Previous page'">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>

            <li class="page-item active">
              <a class="page-link">{{ currentPage }}</a>
            </li>

            <li class="page-item" [class.disabled]="currentPage === tasksPagination.totalPages">
              <a class="page-link" (click)="onPageChange(currentPage + 1)" [attr.aria-label]="'Next page'">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === tasksPagination.totalPages">
              <a class="page-link" (click)="onPageChange(tasksPagination.totalPages)" [attr.aria-label]="'Last page'">
                <span aria-hidden="true">&raquo;&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="pagination-info">
        <span>Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize,
          tasksPagination.totalRecords) }} of {{ tasksPagination.totalRecords }} tasks</span>
      </div>
    </div>
  </div>
</div>

<ng-template #applyTaskModal>
  <div class="modal-header">
    <div class="title">Apply for: {{ selectedTask?.memberShopProduct?.name }}</div>
    <button type="button" aria-label="Close" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column w-100">
      <div class="mb-2">
        <label class="file-label">
          <input type="file" accept="image/*" (change)="onFileChange($event)" />
          <span>Upload image</span>
        </label>
        <div class="preview" *ngIf="previewUrl">
          <img [src]="previewUrl" alt="Preview" />
        </div>
      </div>
      <textarea class="form-control" placeholder="Remark" [(ngModel)]="remark" rows="3"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button class="my-button-3 small outline-secondary" (click)="closeApplyOnly()"
      [disabled]="isSubmitting">Cancel</button>
    <button class="my-button-3 small" [disabled]="!uploadedFile || isSubmitting" (click)="submitApplication()">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{ isSubmitting ? "Submitting..." : "Submit" }}
    </button>
  </div>
</ng-template>

<!-- Task Detail Modal -->
<ng-template #taskDetailModal>
  <div class="modal-header">
    <div class="title">{{ selectedTask?.memberShopProduct?.name || "Task Detail" }}</div>
    <button type="button" aria-label="Close" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex w-100" style="gap: 12px; align-items: flex-start">
      <img [src]="imageUrl + selectedTask?.memberShopProduct?.primaryImage" alt=""
        style="width: 96px; height: 96px; object-fit: cover; border-radius: 8px" />
      <div class="flex-1">
        <div class="mb-1"><strong>Points:</strong> {{ selectedTask?.points }}</div>
        <div class="mb-2"><strong>Description:</strong> {{ selectedTask?.description }}</div>
        <div class="d-flex" style="gap: 8px; flex-wrap: wrap">
          <span class="tag-badge" *ngIf="selectedTask?.tags"
            [ngClass]="{ survey: selectedTask?.tags === 'survey', taste: selectedTask?.tags === 'taste_test', micro: selectedTask?.tags === 'micro_job' }">
            {{ specialTags[selectedTask?.tags] }}
          </span>
          <span class="tag-badge level" *ngIf="selectedTask?.level_required">LVL {{ selectedTask?.level_required
            }}</span>
          <span class="status-icon"
            [ngClass]="{ 'text-success': selectedTask?.is_approved, 'text-warning': selectedTask?.appliedByMe && !selectedTask?.is_approved }">
            <i class="fas"
              [ngClass]="{ 'fa-check-circle': selectedTask?.is_approved, 'fa-hourglass-half': selectedTask?.appliedByMe && !selectedTask?.is_approved, 'fa-clock': !selectedTask?.appliedByMe }"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="my-button-3 small outline-secondary" (click)="closeModal()">Close</button>
    <button class="my-button-3 small" *ngIf="!selectedTask?.appliedByMe && !selectedTask?.isApplied"
      (click)="applyTask(selectedTask)">Accept Task</button>
    <button class="my-button-3 small secondary" *ngIf="selectedTask?.appliedByMe && !selectedTask?.is_file_uploaded"
      (click)="openApplyModal(selectedTask)">Submit Task</button>
  </div>
</ng-template>